import * as React from "react";

const chevronLeftNew: React.FC = () => {
    return (
        <svg viewBox="0 0 6 11" xmlns="http://www.w3.org/2000/svg">
            <path d="m.3 5 5 5 .7-.7L1.7 5 6 .7 5.3 0z" fill="#333F48" fillRule="evenodd"/>
        </svg>
    );
};


export default React.memo(chevronLeftNew);
